import DeviceDetails from './deviceDetails';
import InspectionScreen from './inspection';
import MobileVerification from './mobileLogin';
import React, { useEffect, useState } from 'react'
import TradeinFinalValue from './tradeInFinalValueScreen';
import { Container, Row, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import './deviceDetails.scss'
import './global.scss'
import 'sfy-react/build/css/index.css';
import MobileOtpVerification from './mobileOtpVerfication'
import { useLocation } from 'react-router-dom';
import LinkErrorScreen from './linkErrorScreen';
import servifylogo from './assets/logo.png'
import DotProgressBar from './Controls/DotProgressBar'
import TagManager from 'react-gtm-module';
import AmpleLogo from './assets/Ample.svg'

import { getAmpleStoreDetails } from './apiInstance';
const AmpleContainer = () => {

 const [currentScreen, setScreen] = useState("mobileLogin");
 const location = useLocation();
 let [currentIndex, setCurrentIndex] = useState(0);
 useEffect(() => {
  let AmpleStoreDetails = getAmpleStoreDetails();
  const GTMID = AmpleStoreDetails["GTMID"];
  const tagManagerArgs = {
   gtmId: GTMID || ""
  }
  TagManager.initialize(tagManagerArgs);
 }, []);

 useEffect(() => {
  try {
   const urlParams = new URLSearchParams(location.search || "");
   const data = urlParams.get('data');
   // Decode the String
   let payloadInfo = atob(data);
   if (payloadInfo) {
    let data = JSON.parse(payloadInfo);
    if (data.SessionID) {
     localStorage.setItem("amplePayload", payloadInfo)
    }
    else {
     setScreen("defaultScreen")
    }
   } else {
    setScreen("defaultScreen")
   }
  } catch (e) {
   console.log("error at Ample payload--", e);
   setScreen("defaultScreen")
  }
 })

 let changeScreen = (screen) => {
  //alert(screen)
  setScreen(screen);
 }
 let setCurrentProgressBarIndex = async (step) => {
  setCurrentIndex(step);
 }
 return (
  <Container fluid className="p-0 m-0 g-0 main-container" >
   <Row>
    <Col xs={12}>
     <div className="container_header_logo">
      <img style={{ width: "260px", height: "200px"}} alt="" src={AmpleLogo} />
     </div>
     <div className="container_header_dot_progress">
      <div className="container_header_dot_progress_inner">
       <DotProgressBar currentIndex={currentIndex} progressBarItems={['Basic Info', 'Device Confirmation', 'Device Condition', 'Exchange Value']} showStepCount="true" />
      </div>
     </div>
     <div className="container_body-parent" >
      <div className='container_body_inner container_inner_screen_section'>
       {currentScreen === "mobileLogin" && <MobileVerification changeScreen={changeScreen} />}
       {currentScreen === "otpVerification" && <MobileOtpVerification changeScreen={changeScreen} currentIndex={setCurrentProgressBarIndex} />}
       {currentScreen === "deviceDetails" && <DeviceDetails changeScreen={changeScreen} currentIndex={setCurrentProgressBarIndex} />}
       {/*currentScreen === "skuDetails" && <SkuDetails changeScreen={changeScreen} currentIndex={setCurrentProgressBarIndex}/>*/}
       {currentScreen === "inspection" && <InspectionScreen changeScreen={changeScreen} currentIndex={setCurrentProgressBarIndex} />}
       {currentScreen === "finalScreen" && <TradeinFinalValue changeScreen={changeScreen} currentIndex={setCurrentProgressBarIndex} />}
       {currentScreen === "defaultScreen" && <LinkErrorScreen changeScreen={changeScreen} />}
      </div>
      <div className="container_footer">
       <Container>
        <Row>
         <Col xs={12} md="auto" className='footer_image_block' >
          <span className="jost-font " style={{ fontSize: '11px', color: "#757575", }}>POWERED BY<img style={{ height: '20px', width: 'auto', marginLeft: '4px' }} alt="" src={servifylogo} /></span>

         </Col>
         <Col xs={12} md='auto' className='footer_text_block' >
          <div className="jost-font " style={{ fontSize: "10px", color: "#393939", fontWeight: 400 }}> Servify® is a registered Trademark of Service Lee Technologies Private Limited.</div>
         </Col>

        </Row>
        <Row>
         <Col xs={12} md={12} className='footer_copy_right'>
          <div className="jost-font ">Copyright© 2023</div>
         </Col>
        </Row>
       </Container>
      </div>
     </div>
    </Col>
   </Row>

  </Container>
 );
}
export default AmpleContainer;